import { Component } from '@angular/core';
import { routeAnimations } from '../../shared/animations/router-animation';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
  animations: [routeAnimations]
})
export class UserManagementComponent {

}
